<div
  *ngIf="documentType && status"
  class="document-status {{ status | kebabCase }} icon-wrapper"
>
  {{ 'DOCUMENT.' + documentType + '.STATE.' + status | uppercase | translate }}

  <app-checkmark *ngIf="isPaid" class="icon"> </app-checkmark>
</div>

<app-icon *ngIf="showRecurringIcon" class="icon" [icon]="recurringIcon">
</app-icon>

<app-icon *ngIf="documentState?.datePrinted" class="icon" [icon]="printedIcon">
</app-icon>
